export const GOOGLE_MAPS_SDK_KEY = 'AIzaSyDcNHbenhMf-CHhWkLUCvjgKT6lbI8AyKo';
export const GOOGLE_STREET_VIEW_STATIC_KEY =
  'AIzaSyDWteAiCAN9fM0jQrtFJBHnGVtObVOS09o';
export const GOOGLE_STREET_VIEW_STATIC_PDF_KEY =
  'AIzaSyDGuuNkbpzfJt17_BNEsybhe1E0ZatX69o';
